var _g, _g2, _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOffersPlan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18446_219936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5288 4.84326H4.21087C2.68673 4.84326 1.45117 6.07882 1.45117 7.60296V20.0216C1.45117 21.5457 2.68673 22.7813 4.21087 22.7813H23.5288C25.0529 22.7813 26.2885 21.5457 26.2885 20.0216V7.60296C26.2885 6.07882 25.0529 4.84326 23.5288 4.84326Z",
    stroke: "#E8E8E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.45117 10.3627H25.5985",
    stroke: "#E8E8E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9707 17.2619H9.7304",
    stroke: "#E8E8E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_18446_219936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.1504 14.6245H34.8817V12.087H32.3441V14.6245H19.6564V12.087H17.1188V14.6245H15.85C14.4544 14.6245 13.3125 15.7664 13.3125 17.1621V37.4625C13.3125 38.8581 14.4544 40 15.85 40H36.1504C37.5461 40 38.688 38.8581 38.688 37.4625V17.1621C38.688 15.7664 37.5461 14.6245 36.1504 14.6245ZM36.1504 37.4625H15.85V20.9684H36.1504V37.4625Z",
    fill: "black"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.8701,
    y: 20.8696,
    width: 20.3478,
    height: 16.6087,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5798 24.6224C26.5798 24.3267 26.3397 24.087 26.0436 24.087C25.7474 24.087 25.5073 24.3267 25.5073 24.6224V24.9219C24.8799 24.997 24.3026 25.2035 23.8429 25.5205C23.2528 25.9276 22.8262 26.5449 22.8262 27.2998C22.8262 27.982 23.0898 28.6155 23.6722 29.0629C24.1316 29.4157 24.75 29.6229 25.5073 29.6874V32.3449C25.087 32.2777 24.7247 32.134 24.4525 31.9462C24.0723 31.6839 23.8986 31.3642 23.8986 31.0481C23.8986 30.7523 23.6586 30.5126 23.3624 30.5126C23.0663 30.5126 22.8262 30.7523 22.8262 31.0481C22.8262 31.8029 23.2528 32.4203 23.8429 32.8273C24.3026 33.1444 24.8799 33.3509 25.5073 33.426V33.7254C25.5073 34.0212 25.7474 34.2609 26.0436 34.2609C26.3397 34.2609 26.5798 34.0212 26.5798 33.7254V33.4274C27.203 33.356 27.7797 33.1592 28.2407 32.8464C28.8385 32.441 29.261 31.8211 29.261 31.0481C29.261 30.3484 29.0006 29.7106 28.4115 29.2656C27.9509 28.9178 27.3326 28.7206 26.5798 28.6593V26.003C27.0001 26.0702 27.3625 26.2139 27.6347 26.4017C28.0149 26.6639 28.1885 26.9837 28.1885 27.2998C28.1885 27.5955 28.4286 27.8353 28.7247 27.8353C29.0209 27.8353 29.261 27.5955 29.261 27.2998C29.261 26.5449 28.8344 25.9276 28.2442 25.5205C27.7845 25.2035 27.2072 24.997 26.5798 24.9219V24.6224ZM25.5073 26.003C25.087 26.0702 24.7247 26.2139 24.4525 26.4017C24.0723 26.6639 23.8986 26.9837 23.8986 27.2998C23.8986 27.6885 24.0372 27.9921 24.3261 28.214C24.5652 28.3977 24.9426 28.5519 25.5073 28.6118V26.003ZM26.5798 29.7346V32.3473C27.004 32.2831 27.3671 32.1444 27.6382 31.9605C28.0107 31.7078 28.1885 31.3907 28.1885 31.0481C28.1885 30.6321 28.0467 30.3329 27.7645 30.1197C27.5267 29.9401 27.1491 29.7917 26.5798 29.7346Z",
    fill: "#CA0000"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18446_219936"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.6522,
    height: 27.6522,
    fill: "white",
    transform: "translate(0.0439453)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_18446_219936"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.913,
    height: 27.913,
    fill: "white",
    transform: "translate(12.0439 12.087)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffersPlan);
export default __webpack_public_path__ + "static/media/offersPlan.e3f27058c99e5711b84c237399c6767e.svg";
export { ForwardRef as ReactComponent };